import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PdfLeftPaneState } from '../types/showPdfinLeftPane.types'

const initialState: PdfLeftPaneState = {
  docId: '',
}

const showPdfinLeftPaneSlice = createSlice({
  name: 'pdfinleftpane',
  initialState,
  reducers: {
    showPDF: (
      state: PdfLeftPaneState,
      action: PayloadAction<{
        docId: string
      }>
    ) => {
      state.docId = action.payload.docId
    },
    removePDF: (state: PdfLeftPaneState, action: PayloadAction<{
      docId: string
    }>) => {
      state.docId = action.payload.docId
    }
  },
})

export const { showPDF, removePDF } = showPdfinLeftPaneSlice.actions
export default showPdfinLeftPaneSlice.reducer